(function () {
  function activate(section, tabId) {
    var tabs = section.querySelectorAll('[data-tl-about-tab]');
    var panels = section.querySelectorAll('[data-tl-about-panel]');

    tabs.forEach(function (tab) {
      var active = tab.getAttribute('data-tl-about-tab') === tabId;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      if (active) tab.setAttribute('tabindex', '0');
      else tab.setAttribute('tabindex', '-1');
    });

    panels.forEach(function (panel) {
      var active = panel.getAttribute('data-tl-about-panel') === tabId;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
  }

  function initSection(section) {
    if (!section || section.dataset.tlAboutReady === '1') return;
    section.dataset.tlAboutReady = '1';

    var tabs = section.querySelectorAll('[data-tl-about-tab]');
    if (!tabs.length) return;

    tabs.forEach(function (tab, index) {
      tab.setAttribute('tabindex', index === 0 ? '0' : '-1');

      tab.addEventListener('click', function () {
        activate(section, tab.getAttribute('data-tl-about-tab'));
      });

      tab.addEventListener('keydown', function (event) {
        var key = event.key;
        if (key !== 'ArrowRight' && key !== 'ArrowLeft' && key !== 'Home' && key !== 'End') {
          return;
        }
        event.preventDefault();
        var list = Array.prototype.slice.call(tabs);
        var i = list.indexOf(tab);
        var next = i;
        if (key === 'ArrowRight') next = (i + 1) % list.length;
        if (key === 'ArrowLeft') next = (i - 1 + list.length) % list.length;
        if (key === 'Home') next = 0;
        if (key === 'End') next = list.length - 1;
        list[next].focus();
        activate(section, list[next].getAttribute('data-tl-about-tab'));
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-tl-about]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector
      ? event.target.querySelector('[data-tl-about]')
      : null;
    if (section) {
      section.dataset.tlAboutReady = '0';
      initSection(section);
    }
  });
})();
